// ============================================================================
//  demoMode.js — is this pageview inside /demo, and who is the viewer
//  pretending to be? Persona survives route changes via sessionStorage.
// ============================================================================

import { DEMO_PERSONAS } from "./demoData.js";

const PERSONA_KEY = "milemarker.demo_persona";

export function isDemo() {
  if (typeof window === "undefined") return false;
  const p = window.location.pathname;
  return p === "/demo" || p.startsWith("/demo/");
}

export function getPersonaId() {
  try {
    const saved = sessionStorage.getItem(PERSONA_KEY);
    if (saved && DEMO_PERSONAS.some((p) => p.id === saved)) return saved;
  } catch { /* private mode */ }
  return DEMO_PERSONAS[0].id; // default: the mentee view
}

export function setPersonaId(id) {
  try { sessionStorage.setItem(PERSONA_KEY, id); } catch { /* private mode */ }
}
